// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Mulish', sans-serif;
}

html, body, #root {
  height: 100%;
  overflow: hidden;
}

body {
  background-color: #F7F8FC;
  color: #252733;
}

button, input {
  font-family: 'Mulish', sans-serif;
}

button:focus, input:focus {
  outline: none;
}
/* Thin scrollbar */
.scrollbar-thin {
  scrollbar-width: thin;
  scrollbar-color: #e2e8f0 transparent;
}
.scrollbar-thin::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.scrollbar-thin::-webkit-scrollbar-track {
  background: transparent;
}
.scrollbar-thin::-webkit-scrollbar-thumb {
  background-color: #e2e8f0;
  border-radius: 9999px;
}
.scrollbar-thin::-webkit-scrollbar-thumb:hover {
  background-color: #cbd5e1;
}

/* Hide scrollbar for suggestion buttons row on mobile */
.scrollbar-hide {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;     /* Firefox */
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;             /* Chrome, Safari, Opera */
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;AACA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,MAAM,YAAY;AACzC;AACA;EACE,aAAa,cAAc,0BAA0B;AACvD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Mulish:wght@400;600;700&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Mulish', sans-serif;\n}\n\nhtml, body, #root {\n  height: 100%;\n  overflow: hidden;\n}\n\nbody {\n  background-color: #F7F8FC;\n  color: #252733;\n}\n\nbutton, input {\n  font-family: 'Mulish', sans-serif;\n}\n\nbutton:focus, input:focus {\n  outline: none;\n}\n/* Thin scrollbar */\n.scrollbar-thin {\n  scrollbar-width: thin;\n  scrollbar-color: #e2e8f0 transparent;\n}\n.scrollbar-thin::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n.scrollbar-thin::-webkit-scrollbar-track {\n  background: transparent;\n}\n.scrollbar-thin::-webkit-scrollbar-thumb {\n  background-color: #e2e8f0;\n  border-radius: 9999px;\n}\n.scrollbar-thin::-webkit-scrollbar-thumb:hover {\n  background-color: #cbd5e1;\n}\n\n/* Hide scrollbar for suggestion buttons row on mobile */\n.scrollbar-hide {\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;     /* Firefox */\n}\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;             /* Chrome, Safari, Opera */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
